<p-table [columns]="cols" 
         [value]="items" 
         [tableStyle]="{ 'min-width': '50rem' }"
         [paginator]="true" 
         [rows]="10"
        [rowsPerPageOptions]="[5, 10, 20, 50]">
    <ng-template #header let-columns>
        <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                {{ col.header }} <p-sortIcon [field]="col.field" />
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-rowData let-columns="columns">
        @if(followPath) {
         <tr [routerLink]="followUrl(rowData[idField])">
                        <td *ngFor="let col of columns" >
                {{ rowData[col.field] }}
            </td>
        </tr>
        } @else {
         <tr>
            <td *ngFor="let col of columns" >
                {{ rowData[col.field] }}
            </td>
        </tr>
        }
       

    </ng-template>
</p-table>